<div class="modal">
	<div class="modal-content-alert-mg w-4/5 md:!w-[calc(500px)]">
		<div class="content">
			<div class="modal-header-alert">
				<span class="font-semibold text-2xl">{{ content.title }}</span>
				<mat-icon class="close cursor-pointer" (click)="closeModal(false)" style="font-size: 25px"
					>close</mat-icon
				>
			</div>
			<hr />
			<div class="modal-body-alert-mg">
				<p>{{ content.text1 }} {{ elementsDelete }} {{ content.text2 }}</p>
			</div>
			<div class="modal-footer-alert-mg">
				<div class="buttons flex items-center">
					<button class="mg-button button-translucent items-center" (click)="closeModal(false)">
						<span>{{ content.buttonCancel }}</span>
					</button>
				</div>
				<div class="buttons flex items-center" style="margin: 10px" *ngIf="content.buttonOk">
					<button
						class="mg-button bg-primary-color text-white button-green items-center"
						(click)="closeModal(true)"
					>
						<span>{{ content.buttonOk }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
